import { render, staticRenderFns } from "./ProfessionalInterventionInvoiceQuestion.vue?vue&type=template&id=48e17039"
import script from "./ProfessionalInterventionInvoiceQuestion.vue?vue&type=script&lang=ts"
export * from "./ProfessionalInterventionInvoiceQuestion.vue?vue&type=script&lang=ts"
import style0 from "./ProfessionalInterventionInvoiceQuestion.vue?vue&type=style&index=0&id=48e17039&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports